import { styled, Typography } from "@material-ui/core";
import BackButton from "../../components/BackNavigation/BackButton";

export const ImgWrapper = styled(`img`)(({ theme }) => ({
  width: "100%",
  height: "400px",
  objectFit: "cover",
  [theme.breakpoints.up(`md`)]: {
    height: "595px"
  }
}));

export const SubtitleTextWrapper = styled(Typography)(({}) => ({
  fontFamily: "Roobert",
  fontWeight: 400,
  fontSize: "2rem",
  color: "#FFFFFF",
  lineHeight: "2.4rem"
}));

export const LabelTextWrapper = styled(`div`)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  alignContent: "center",
  color: "#FFFFFF", //AccessTimeIcon inherits from this color
  paddingBottom: "11px",
  [theme.breakpoints.down(`sm`)]: {
    paddingBottom: "8.5px"
  }
}));

export const CaptionLabelText = styled(Typography)(({ theme }) => ({
  fontFamily: "Roobert",
  fontWeight: 600,
  fontSize: "1.2rem",
  color: "#FFFFFF",
  lineHeight: "1.6rem",
  letterSpacing: "1.5px",
  [theme.breakpoints.only(`sm`)]: {
    fontSize: "1rem"
  }
}));

export const WhiteBackButton = styled(BackButton)(({}) => ({
  color: "white",
  lineHeight: "1.6rem",
  letterSpacing: "1.5px"
}));
